import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import videojs from 'video.js';
import { Col } from 'reactstrap';

import 'video.js/dist/video-js.css';

const Video = ({ video }) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);

  const videoPath = `/videos/feature-showcase-videos/${video}.webm`;

  useEffect(() => () => {
    if (playerRef.current) {
      playerRef.current.dispose();
      playerRef.current = null;
    }
  }, []);

  useEffect(() => {
    if (!videoRef.current || !videoPath) return () => {};

    if (playerRef.current) {
      playerRef.current.dispose();
      playerRef.current = null;
    }

    playerRef.current = videojs(videoRef.current, {
      controls: false,
      autoplay: true,
      muted: true,
      preload: 'auto',
      loop: true,
      sources: [
        {
          src: videoPath,
          type: 'video/webm',
        },
      ],
    });

    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, [videoPath]);

  return (
    <Col lg="7" xs="12" className="empty-state-video">
      <div data-vjs-player>
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video
          ref={videoRef}
          className="video-js vjs-default-skin"
          playsInline
        />
      </div>
    </Col>
  );
};

Video.propTypes = {
  video: PropTypes.object.isRequired,
};

export default Video;
